import i18n from '@/plugins/i18n.js';

export const ConfirmDialog = {
  namespaced: true,

  state: {
    globalConfirmDialogProperties: {
      displayDialog: false,
      persistent: false,
      //text
      title: null,
      message: null,
      //buttons
      dontRemindMeKey: null,
      confirmbutton: {},
      cancelbutton: {},
      //termination variables
      resolvePromise: undefined,
      rejectPromise: undefined,
    },
  },

  mutations: {
    SHOW_GLOBAL_CONFIRM_DIALOG(state, payload) {
      state.globalConfirmDialogProperties = payload;
    },
    CONFIRM_GLOBAL_CONFIRM_DIALOG(state) {
      state.globalConfirmDialogProperties.resolvePromise(true);
      state.globalConfirmDialogProperties.displayDialog = false;
    },
    CONDITIONAL_CONFIRM_GLOBAL_CONFIRM_DIALOG(state) {
      state.globalConfirmDialogProperties.resolvePromise('conditionally');
      state.globalConfirmDialogProperties.displayDialog = false;
    },
    CANCEL_GLOBAL_CONFIRM_DIALOG(state) {
      state.globalConfirmDialogProperties.resolvePromise(false);
      state.globalConfirmDialogProperties.displayDialog = false;
    },
  },

  actions: {
    async Show({ commit }, config) {
      var dialogproperties = {
        displayDialog: true,
        persistent: config && (config.persistent === true) ? config.persistent : false,
        //text
        title: config && config.title ? config.title : i18n.t('servicesystem.common_objects.fallbackterms.confirm_title'),
        message: config && config.message ? config.message : i18n.t('servicesystem.common_objects.fallbackterms.confirm_body'),
        //buttons
        dontRemindMeKey: config && config.dontRemindMeKey,
        confirmbutton: config && config.confirmbutton ? config.confirmbutton : {
          text: i18n.t('servicesystem.common_objects.commonterms.confirm'),
          icon: "mdi-check",
          color: 'primary',
          outlined: false
        },

        conditionalconfirmbutton: config && config.conditionalconfirmbutton ? config.conditionalconfirmbutton : null,

        cancelbutton: config && config.cancelbutton ? config.cancelbutton : {
          text: i18n.t('servicesystem.common_objects.commonterms.cancel'),
          icon: "mdi-close",
          color: 'close',
          outlined: true
        },
        //termination variables
        resolvePromise: undefined,
        rejectPromise: undefined,
      }

      commit('SHOW_GLOBAL_CONFIRM_DIALOG', dialogproperties)

      return new Promise((resolve, reject) => {
        dialogproperties.resolvePromise = resolve;
        dialogproperties.rejectPromise = reject;
      });
    },
    Confirm({ commit }) {
      commit('CONFIRM_GLOBAL_CONFIRM_DIALOG')
    },
    ConditionalConfirm({ commit }) {
      commit('CONDITIONAL_CONFIRM_GLOBAL_CONFIRM_DIALOG')
    },
    Cancel({ commit }) {
      commit('CANCEL_GLOBAL_CONFIRM_DIALOG')
    },
  },

  getters: {
    Properties: state => {
      return state.globalConfirmDialogProperties;
    },
  },
};
